<template>
  <div v-if="!hasFetched">
    <Fetching />
  </div>

  <div v-else-if="hasFetched && !error && !profile.error" class="swiper-card card-invite">
    <div class="corner-radius-blur"></div>
    <div class="profile-image-wrap">
      <div class="profile-image" v-if="getProfileImage">
        <svg width="35" height="73" viewBox="0 0 35 73" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.1953 72.1886C27.0093 72.3665 27.7381 71.469 28.0323 70.8408C28.2505 70.3746 28.652 69.0155 27.8904 68.676C22.7561 66.3872 17.8901 63.337 14.0227 58.9862C10.1961 54.6811 7.3201 49.5326 5.78655 44.0104C5.03432 41.3023 4.63733 38.6609 4.62822 35.914C4.62585 35.2286 4.64676 34.5451 4.69098 33.8651C4.73636 33.1678 4.76322 32.9448 4.88395 32.1236C4.98041 31.4672 5.09824 30.8159 5.23703 30.1712C5.30164 29.8705 5.37141 29.5714 5.44519 29.2735C5.48738 29.1033 5.53083 28.9337 5.57609 28.7646C5.58779 28.7204 5.63595 28.5572 5.66345 28.4626C6.04914 27.2078 6.50285 25.9831 7.03627 24.7982C7.08896 24.6811 7.26181 24.3257 7.2885 24.2663C7.41335 24.0202 7.53808 23.774 7.669 23.5313C7.99502 22.9266 8.3404 22.3344 8.70432 21.7555C8.8637 21.502 9.02681 21.2513 9.19318 21.003C9.26392 20.8973 9.4713 20.6021 9.51821 20.532C9.8811 20.0357 10.2538 19.5474 10.6434 19.0743C11.0486 18.5821 11.4685 18.1033 11.9025 17.6385C12.1051 17.4216 12.313 17.2108 12.5187 16.9971C12.5576 16.9566 12.5882 16.9248 12.6143 16.8976C12.7447 16.7724 12.8766 16.6486 13.0095 16.5263C14.0963 15.5253 15.2543 14.6064 16.4751 13.7807C16.5796 13.7101 16.685 13.6409 16.7901 13.5711C16.8393 13.5391 16.87 13.5191 16.8846 13.5092C16.9198 13.4874 16.955 13.4656 16.9902 13.4436C17.3138 13.2478 17.6385 13.0545 17.9684 12.8694C18.5909 12.5203 19.2265 12.1944 19.8747 11.8938C21.4455 11.1647 23.0177 10.5696 24.6315 10.0543C24.4262 10.2649 24.222 10.4759 24.0201 10.6875C21.3257 13.5089 18.9907 16.6395 17.3441 20.2747C17.0444 20.9365 16.9173 22.2298 17.6741 22.752C18.4385 23.2796 19.4464 22.5998 19.8957 22.0358C21.9589 19.4455 23.9099 16.7508 26.1581 14.3296C28.3287 11.992 30.8498 10.0896 33.3961 7.95789C34.1723 7.30805 34.7875 6.29567 34.8601 5.21476C34.9065 4.52585 34.7318 3.39624 33.8355 3.29634C30.4929 2.92444 27.1306 2.25427 23.7931 1.73967C22.1794 1.49085 20.5654 1.24714 18.9511 1.00765C17.2422 0.754158 15.3812 0.341405 13.6906 0.549159C12.7731 0.662067 11.2044 2.99389 12.4666 3.73751C13.9155 4.59102 15.7786 4.83483 17.3565 5.19814C18.7137 5.51079 20.0713 5.81842 21.4295 6.12408C18.5504 7.18706 15.8806 8.83333 13.4966 10.7318C8.76021 14.5039 5.02835 19.5971 2.79502 25.4228C0.586916 31.1826 -0.0164303 37.5872 1.20711 43.9436C2.37496 50.0101 5.26194 55.8959 9.21262 60.721C13.6334 66.1213 19.5851 70.7434 26.1953 72.1886Z" fill="#FFDE00"/>
        </svg>
        <img :src="getProfileImage" :alt="profile.name" />
      </div>
    </div>

    <div class="main">
      <div class="onboarding-content">
        <h3>Discover <span class="callout">Nourish</span> with {{ profile.name }}.</h3>
        <p>Nourish is radically different news, with only what you need to know. </p>
      </div>
      <div class="meta-block">
        <MetaBlock :items="meta" />
      </div>
    </div>
  </div>

  <div v-else class="swiper-card card-invite">
    <h1>Uh oh, sorry. We couldn't find that profile.</h1>
    <p>Double check the link you we're sent and try again. If you're still having trouble, get in touch.</p>
    <RouterLink to="/contact" class="button">Contact us</RouterLink>
  </div>
</template>

<script>
  import API from 'app/axios';
  import Fetching from '@/components/v5/Fetching.vue';
  import MetaBlock from '@/components/v5/elements/MetaBlock.vue';

  export default {
    data() {
      return {
        hasFetched: false,
        profile: {},
        error: null,
        features: [
          `Feel better`,
          `Feel more informed`,
          `Feel less anxious about the future`,
          `Understand more about the world`,
        ],
        meta: [
          {
            icon: 'meta-book',
            content: `No clickbait,<br>just facts`
          },
          {
            icon: 'meta-money',
            content: `Free,<br>forever`
          },
        ]
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      Fetching,
      MetaBlock
    },

    mounted () {
      this.hasFetched = false;

      if (this.getHandle) {
        API.getThreadsScreenName(this.getHandle).then((response) => {
          console.error('Fetch:', response);
          this.error = response.error;
          this.profile = response.profile; 
          this.hasFetched = true;
        }).catch((error) => {
          console.error('Error', error);
          this.hasFetched = true;
          this.error = true;
        })
      } else {
          console.error('Wait, what? ', this.getHandle);
      }
      this.$emit('swiperUpdate')
    },

    computed: {
      getHandle() {
        return this.$route.query.u || this.$userEngine.getOnboardMemo()?.['invited_by'];
      },

      getProfileImage() {
        if (!this.profile || !this.profile.avatar || this.profile.avatar === "https://nourished.news") {
          return false;
        }
        return this.profile.avatar;
      },
    },

    methods: {
      next() {
        this.$emit('next');
      }
    },

    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            this.$emit('enableNextAction');
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-invite {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    max-width: 550px;
    margin: 0 auto;
    overflow-x: hidden;
    height: 100%;
    padding: 2rem 0;

    .next {
      display: none;
    }

    .main {
      position: relative;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      text-align: left;
      gap: 1rem;
      margin-top: 4rem;
      height: 100%;

      .desktop & {
        align-items: center;
        text-align: center;
      }

      .onboarding-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
      }

      .meta-block {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
        margin-top: 1rem;
      }
    }

    .profile-image-wrap {
      position: relative;
      z-index: 10;

      .profile-image {
        width: 8rem;
        height: 8rem;
        padding: 0.7rem;
        border-radius: 500px;
        border: 6px solid rgba($neutral-100, 0.07);
        overflow: hidden;
        margin: auto;

        .desktop & {
          padding: 1rem;
          border: 7px solid rgba($neutral-100, 0.07);
          width: 11rem;
          height: 11rem;
        }

        .darkmode & {
          border-color: rgba($neutral-600, 0.1);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      svg {
        position: absolute;
        bottom: 0;
        left: -40px;
        height: 50px;
        
        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }

        .desktop & {
          height: 67px;
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 38px;
      line-height: 110%;
      text-wrap: balance;

      .callout {
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }

      .desktop & {
        font-size: 50px;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;

      .desktop & {
        max-width: 400px;
      }
    }

    ul {
      margin-top: 1rem;

      li {
        display: flex;
        align-items: center;
        font-size: 18px;
        margin-bottom: 1rem;


        svg {
          margin-right: 1rem;

          path {
            fill: $green-tone-3;
          }
        }
      }
    }
  }
</style>